<ion-footer class="footer main w-100 d-flex align-items-center justify-content-center ion-no-margin">
  <!-- Footer navigation container -->
  <div class="menu-footer-container d-flex justify-content-center text-decoration-none">
    <!-- Footer menu list -->
    <ul id="menu-footer" class="menu ion-no-margin ion-no-padding">
      <!-- Privacy policy link -->
      <li class="menu-item d-inline-block">
        <a class="text-decoration-none" [href]="privacyUrl" target="_blank" rel="noopener">
          <ion-text class="text-white" translate>
            LINK2
          </ion-text>
        </a>
      </li>
    </ul>
  </div>
</ion-footer>